module.exports = __webpack_public_path__ + "images/08-02@2x_3143b4bb.png";